import { ChevronDown, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { logout } from '@/features/auth/authService';
import { useAuthStore } from '@/stores/auth';
import { useMe } from '@/features/auth/useMe';

export function UserMenu() {
  const navigate = useNavigate();
  const sessionUser = useAuthStore((s) => s.user);
  const { data: me } = useMe();

  const name = me?.name ?? sessionUser?.name ?? 'M. Ríos';
  const role = me?.roles?.[0] ?? sessionUser?.roles?.[0] ?? 'Coordinación';

  async function onLogout() {
    await logout();
    navigate('/login', { replace: true });
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          title="Cuenta"
          className="flex cursor-pointer items-center gap-[9px] rounded-[8px] border border-c-line py-[5px] pl-[6px] pr-[9px] transition-colors hover:bg-c-hover-bg"
        >
          <span className="h-[26px] w-[26px] flex-none rounded-[6px] bg-[linear-gradient(135deg,#1fd39a,#3aa0ff)]" />
          <span className="text-left leading-[1.2]">
            <span className="block text-[11.5px] font-semibold text-c-text">
              {name}
            </span>
            <span className="block font-mono text-[8.5px] text-c-mid">
              {role}
            </span>
          </span>
          <ChevronDown size={12} className="text-c-dim" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{me?.tenant.nombre ?? 'Pozuelo de Alarcón'}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onLogout} className="text-s-bad">
          <LogOut size={15} />
          Cerrar sesión
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
